/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../common";
import type {
  SafetyBoxLogic,
  SafetyBoxLogicInterface,
} from "../../../contracts/safetyBox/SafetyBoxLogic";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    stateMutability: "payable",
    type: "fallback",
  },
  {
    inputs: [],
    name: "accessControl",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155BatchReceived",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC721Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newAssociatedOperator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "flag",
        type: "bool",
      },
    ],
    name: "setAssociatedOperator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "takeErc1155",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "takeErc20",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "takeErc721",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
] as const;

const _bytecode =
  "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";

type SafetyBoxLogicConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: SafetyBoxLogicConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class SafetyBoxLogic__factory extends ContractFactory {
  constructor(...args: SafetyBoxLogicConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<SafetyBoxLogic> {
    return super.deploy(overrides || {}) as Promise<SafetyBoxLogic>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): SafetyBoxLogic {
    return super.attach(address) as SafetyBoxLogic;
  }
  override connect(signer: Signer): SafetyBoxLogic__factory {
    return super.connect(signer) as SafetyBoxLogic__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): SafetyBoxLogicInterface {
    return new utils.Interface(_abi) as SafetyBoxLogicInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): SafetyBoxLogic {
    return new Contract(address, _abi, signerOrProvider) as SafetyBoxLogic;
  }
}
